/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../common";
import type {
  SafetyBoxLogic,
  SafetyBoxLogicInterface,
} from "../../../contracts/safetyBox/SafetyBoxLogic";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    stateMutability: "payable",
    type: "fallback",
  },
  {
    inputs: [],
    name: "accessControl",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155BatchReceived",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC721Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newAssociatedOperator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "flag",
        type: "bool",
      },
    ],
    name: "setAssociatedOperator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "takeErc1155",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "takeErc20",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "takeErc721",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
] as const;

const _bytecode =
  "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";

type SafetyBoxLogicConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: SafetyBoxLogicConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class SafetyBoxLogic__factory extends ContractFactory {
  constructor(...args: SafetyBoxLogicConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<SafetyBoxLogic> {
    return super.deploy(overrides || {}) as Promise<SafetyBoxLogic>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): SafetyBoxLogic {
    return super.attach(address) as SafetyBoxLogic;
  }
  override connect(signer: Signer): SafetyBoxLogic__factory {
    return super.connect(signer) as SafetyBoxLogic__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): SafetyBoxLogicInterface {
    return new utils.Interface(_abi) as SafetyBoxLogicInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): SafetyBoxLogic {
    return new Contract(address, _abi, signerOrProvider) as SafetyBoxLogic;
  }
}
